var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author HyeongJin O
 * @contact hjoh@detech.co.kr
 * @date 2022-07-19
 * @brief EHP 기기등록 관리 - List 개발
 *
 ********************************************************************/
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useAsync } from "react-async";
// recoil
import { useRecoilValue, useRecoilState, } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
import * as CONST from "../../../utils/Const";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
// component
import EhpPagination from "../../common/pagination/EhpPagination";
//
import * as XLSX from 'xlsx';
import * as FileSaver from "file-saver";
import { loadingBoxState } from "../../../recoil/menuState";
import { useTrans } from "../../../utils/langs/useTrans";
/**
 * @brief EHP 기기등록 관리 - List 컴포넌트 , 반응형 동작
 * @param -
 * @returns react components
 */
//component
function DeviceList(props) {
    //trans
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    //props
    const isMobile = props.isMobile;
    const curTree = props.curTree;
    const workMode = props.workMode;
    const setParentIsMobile = props.setIsMobile;
    const setParentWorkMode = props.setWorkMode;
    const setParentPopWin = props.setPopWin;
    const reWork = props.reWork;
    const setReWork = props.setReWork;
    // by hjo - 20220920 - 추가 hook
    const setListWork = props.setListWork;
    const listItem = props.listItem;
    const setListItem = props.setListItem;
    const restart = props.restart;
    const setRestart = props.setRestart;
    const setNodata = props.setNodata;
    //mobile check
    const mobileRef = useRef(null); // Mobile Check용
    const searchRef = useRef(null); // searchBox pop Check용
    const [isSearchPop, setIsSearchPop] = useState(false);
    const [listReload, setListReload] = useState(false);
    useEffect(() => {
        function handleResize() {
            if (CUTIL.isnull(mobileRef))
                return;
            const mobileTag = mobileRef.current;
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setParentIsMobile(true);
            }
            else {
                setParentIsMobile(false);
            }
            // search popup check......
            if (CUTIL.isnull(searchRef))
                return;
            const searchTag = searchRef.current;
            // clog("handleResize : " + searchTag.clientHeight + " X " + searchTag.clientWidth);
            if (!CUTIL.isnull(searchTag)) {
                if ((searchTag.clientHeight <= 0) && (searchTag.clientWidth <= 0)) {
                    setIsSearchPop(true);
                }
                else {
                    setIsSearchPop(false);
                }
            }
        }
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        if (CUTIL.isnull(mobileRef))
            return;
        const mobileTag = mobileRef.current;
        if (!CUTIL.isnull(mobileTag)) {
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setParentIsMobile(true);
            }
            else {
                setParentIsMobile(false);
            }
        }
    }, [isMobile]);
    //
    useEffect(() => {
        if (CUTIL.isnull(searchRef))
            return;
        const searchTag = searchRef.current;
        if (!CUTIL.isnull(searchTag)) {
            if ((searchTag.clientHeight <= 0) && (searchTag.clientWidth <= 0)) {
                setIsSearchPop(true);
            }
            else {
                setIsSearchPop(false);
            }
        }
    }, [isMobile]);
    //
    const [searchText, setSearchText] = useState("");
    const [searchTextField, setSearchTextField] = useState({
        searchField: "",
        searchText: ""
    });
    const [deviceList, setDeviceList] = useState([]);
    const defaultPageInfo = { "size": 10, "totalElements": 0, "totalPages": 0, "number": 0, "psize": 10, "listReload": false };
    const [sortData, setSortData] = useState({ "sortField": "rownumber", "sort": "ASC" });
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    const [listChang, setListChang] = useState(false);
    //
    const [checkItem, setCheckItem] = useState([]);
    const [errorList, setErrorList] = useState([]);
    const [excelData, setExcelData] = useState([]);
    //
    let appPath = "roomId=" + curTree.room.roomId;
    appPath = appPath + '&page=' + pageInfo.number + '&size=' + pageInfo.size;
    appPath = appPath + '&sort=' + sortData.sortField + ',' + sortData.sort;
    if (searchTextField.searchText.length > 0) {
        appPath = appPath + `&${searchTextField.searchField}=` + searchTextField.searchText;
    }
    /*
    appPath = appPath + '&page=' + curPage + '&size=' + listSize
    appPath = appPath + '&sort=' + sortData.sortField + ',' + sortData.sort;
    // // 검색
    if (!CUTIL.isnull(searchType) && (searchType.length > 0) && (searchRText.length > 0)) {
      appPath = appPath + '&' + searchType + '=' + searchRText;
      clog("검색 액션 : " + appPath);
    }
    */
    useEffect(() => {
        setParentPopWin("pop-search-small", React.createElement(MobileSearchPopup, { searchText: searchText, setSearchText: setSearchText, onClickGoSearch: onClickGoSearch }));
        setNodata(pageInfo.totalElements);
        if (reWork !== curTree) {
            setSearchText("");
            setSearchTextField({
                searchField: "",
                searchText: ""
            });
            setSortData({ "sortField": "rownumber", "sort": "ASC" });
            handleCurPage(0);
            setCheckItem([]);
        }
    }); // searchText 이벤트 반영하기 위해서, 모든 스테이트 반영
    //////////////////////////////////
    // 일괄 삭제 이벤트 및 팝업
    function listCheckDelPop(e, delList) {
        var itemId = [];
        for (let i = 0; i < delList.length; i++) {
            itemId.push(delList[i].itemId);
        }
        setReloadList(false);
        setParentPopWin("pop-delete", React.createElement(CheckDeletePopup, { htmlHeader: React.createElement("h1", null, "\uAE30\uAE30 \uC0AD\uC81C"), listItem: itemId, setListChang: setListChang, mobileRef: mobileRef, setParentPopWin: setParentPopWin, setListWork: setListWork, setListItem: setListItem, pageInfo: pageInfo, setPageInfo: setPageInfo, deviceList: deviceList, setDeviceList: setDeviceList, setReloadList: setReloadList, errorList: errorList, setErrorList: setErrorList, setCheckItem: setCheckItem, handleCurPage: handleCurPage, setRecoilIsLoadingBox: setRecoilIsLoadingBox }));
        CUTIL.jsopen_Popup(e);
    }
    ;
    // 단일 삭제 이벤트 및 팝업
    function listDelPop(e, delList) {
        setReloadList(false);
        setParentPopWin("pop-delete", React.createElement(DeletePopup, { htmlHeader: React.createElement("h1", null, "\uAE30\uAE30 \uC0AD\uC81C"), listItem: delList.itemId, setListChang: setListChang, mobileRef: mobileRef, setParentPopWin: setParentPopWin, setListWork: setListWork, setListItem: setListItem, pageInfo: pageInfo, setPageInfo: setPageInfo, deviceList: deviceList, setDeviceList: setDeviceList, setReloadList: setReloadList, errorList: errorList, setErrorList: setErrorList, setCheckItem: setCheckItem, handleCurPage: handleCurPage }));
        CUTIL.jsopen_Popup(e);
    }
    ;
    const [reloadList, setReloadList] = useState(false);
    const { data: retDevice, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: '/api/v2/product/company/zone/subzone/room/panel/itemManageList?' + appPath,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + reloadList + restart + curTree.reload + listReload
    });
    useEffect(() => {
        if (retDevice) {
            if (retDevice.codeNum == CONST.API_200) {
                setReloadList(false);
                setDeviceList(retDevice.body);
                setPageInfo(Object.assign(Object.assign({}, retDevice.data.page), { psize: (isMobile) ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT, "listReload": false })); //5, 10
                setParentPopWin("pop-list", React.createElement(MobileDeviceList, { htmlHeaderBtn: React.createElement("button", { className: "btn btn-close js-close", onClick: (e) => listPopCloes(e) },
                        React.createElement("span", { className: "hide" }, "\uB2EB\uAE30")), curTree: curTree, workMode: workMode, searchText: searchText, setSearchText: setSearchText, onClickGoSearch: onClickGoSearch, deviceList: retDevice.body, pageInfo: Object.assign(Object.assign({}, retDevice.data.page), { psize: (isMobile) ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT, "listReload": false }), setPageInfo: handleCurPage, 
                    // onClickDeviceDetailView={onClickDeviceDetailView}
                    onClickDeviceTab: onClickDeviceTab, sortData: sortData, onClickSort: onClickSort, setListWork: setListWork, setListItem: setListItem, setRestart: setRestart, 
                    //
                    onClickDeviceChang: onClickDeviceChang, 
                    //
                    mobileRef: mobileRef, setParentPopWin: setParentPopWin, listDelPop: listDelPop }));
            }
        }
    }, [retDevice]);
    function listPopCloes(e) {
        setSearchText("");
        setSearchTextField({
            searchField: "",
            searchText: ""
        });
        onClickGoSearch;
        CUTIL.jsclose_Popup("pop-list");
    }
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    //
    function onClickGoSearch(e) {
        handleCurPage(0);
        setSearchTextField({
            searchField: "",
            searchText: ""
        });
        var searchTypeDiv = document.querySelector("#search_selected-value");
        if (CUTIL.isnull(searchTypeDiv))
            return;
        var selSearchType = searchTypeDiv.getAttribute("data-value");
        setSearchTextField({
            searchField: selSearchType,
            searchText: searchText
        });
    }
    //
    //chcek All
    const checkedAll = useCallback((checked) => {
        if (checked) {
            const checkedArray = [];
            deviceList.forEach((list) => { checkedArray.push(list); });
            setCheckItem(checkedArray);
        }
        else {
            setCheckItem([]);
        }
    }, [deviceList]);
    // check singe
    const checkedList = useCallback((checked, list) => {
        if (checked) {
            setCheckItem([...checkItem, list]);
        }
        else {
            setCheckItem(checkItem.filter((el) => el !== list));
        }
    }, [checkItem]);
    //
    function onClickSelectOnly(e, device) {
        setDeviceList(deviceList.map((dev) => (dev.itemId === device.itemId) ? Object.assign(Object.assign({}, dev), { selected: true }) : Object.assign(Object.assign({}, dev), { selected: false })));
    }
    function onClickSort(sort) {
        // list 수정
        handleCurPage(0);
        var selSort = (sortData.sort === "ASC") ? "DESC" : "ASC";
        if (sort !== sortData.sortField) { // 정렬필드가 변경된 경우
            selSort = "DESC";
        }
        setSortData({
            "sortField": sort,
            "sort": selSort
        });
    }
    function onClickDeviceChang(e, device) {
        setListWork(true);
        if (CUTIL.isnull(device))
            return;
        setListItem(device);
        setRestart(false);
    }
    // 엑셀 다운로드 시 리스트 API
    function excelList(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let appPath = "roomId=" + curTree.room.roomId;
            appPath = appPath + '&page=' + pageInfo.number + '&size=' + pageInfo.totalElements;
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "GET",
                appPath: '/api/v2/product/company/zone/subzone/room/panel/itemManageList?' + appPath,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
                watch: appPath
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    excelDownloadSaved(data.body);
                }
            }
        });
    }
    function excelDownloadSaved(excelData) {
        const excelFileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'; // 파일 타입 및 유니코드
        // const book = XLSX.utils.book_new();
        const excelFileExtension = '.xlsx'; // 확장자 명
        const excelFileName = curTree.company.companyName + "_" + curTree.zone.zoneName + "_" + curTree.subZone.subZoneName + "_" + curTree.room.roomName + "_" + "DeviceList"; // 파일명
        const excelSheet = XLSX.utils.aoa_to_sheet([
            ['no', '기기유형', 'Panel명', "정격전압(kV)", "2차전압(kV)", "정격전류(A)", "차단전류(kA)", "정격용량(kVA)", "모델명", "시리얼번호", "제조사", "메모"]
        ]);
        excelData.map((sheet) => {
            XLSX.utils.sheet_add_aoa(excelSheet, [
                [
                    sheet.rowNumber,
                    sheet.spg.spgName,
                    sheet.panel.panelName,
                    sheet.ratingVoltage,
                    sheet.secondaryVoltage,
                    sheet.ratingCurrent,
                    sheet.cutoffCurrent,
                    sheet.ratedCapacity,
                    sheet.itemName,
                    sheet.serialNo,
                    sheet.manufacturer,
                    sheet.memo,
                ]
            ], { origin: -1 });
            excelSheet['!cols'] = [
                { width: 8, },
                { width: 10, },
                { width: 20, },
                { width: 13, },
                { width: 13, },
                { width: 13, },
                { width: 13, },
                { width: 13, },
                { width: 30, },
                { width: 30, },
                { width: 30, },
                { width: 30, },
            ];
            return false;
        });
        // wb == workBook 약자
        const wb = { Sheets: { Sheet: excelSheet }, SheetNames: ["Sheet"] };
        const excelButter = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const excelFile = new Blob([excelButter], { type: excelFileType });
        FileSaver.saveAs(excelFile, excelFileName + excelFileExtension);
        // XLSX.utils.book_append_sheet(book, excelSheet, "Sheet"); 
        // XLSX.writeFile(book, excelFileName + excelFileExtension);
    }
    // 
    /* // 기존 모바일 리스트 팝업
       function onClickDeviceDetailView(e, device) {
        setParentPopWin("pop-list-view",
          <MobileDeviceDetail
            htmlHeader={<h1>{device.itemName}</h1>}
            deviceInfo={device}
          />
        );
        //deviceList.filter((dev))
        clog("onClickDeviceDetailView : " + JSON.stringify(device));
        CUTIL.jsopen_m_Popup(e);
      } */
    function onClickDeviceTab(e, workMode) {
        //  clog("DeviceList : onClickDeviceTab : " + workMode + " : " + isMobile);
        CUTIL.jsopen_s_Popup(e, isMobile);
        setParentWorkMode(workMode);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "area__right", ref: mobileRef },
            React.createElement("ul", { className: "page-loca" },
                React.createElement("li", null, curTree.company.companyName),
                React.createElement("li", null, curTree.zone.zoneName),
                React.createElement("li", null, curTree.subZone.subZoneName),
                React.createElement("li", null, curTree.room.roomName)),
            React.createElement("h2", null, curTree.room.roomName),
            React.createElement("div", { className: "inline mb-18" },
                React.createElement("a", { href: "#", className: `move-list ${(workMode === "LIST") ? "active" : ""}`, onClick: (e) => onClickDeviceTab(e, "LIST") }, "Device List"),
                React.createElement("ul", { className: "tab__small" },
                    React.createElement("li", { className: (workMode === "BATCH") ? "on" : "" },
                        React.createElement("a", { href: "#", className: "icon-add", onClick: (e) => onClickDeviceTab(e, "BATCH") }, t("LABEL.일괄등록"))),
                    React.createElement("li", { className: (workMode === "CREATE") ? "on" : "" },
                        React.createElement("a", { href: "#", className: "icon-pen", onClick: (e) => onClickDeviceTab(e, "CREATE") }, t("LABEL.개별등록"))))),
            React.createElement("div", { className: "area__right_content " },
                React.createElement("div", { className: "inline right search-small mb-16 p-0 js-open-m open", "data-pop": "pop-search-small" },
                    React.createElement("p", { className: "title" },
                        React.createElement("span", { className: "txt-black" }, t("LABEL.검색"))),
                    React.createElement("div", { className: "searcharea" },
                        React.createElement("div", { className: "searchinput" },
                            React.createElement("div", { className: "select", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption), ref: searchRef },
                                React.createElement("div", { className: "selected" },
                                    React.createElement("div", { id: "search_selected-value", className: "selected-value", "data-value": "itemName" }, t("FIELD.모델명")),
                                    React.createElement("div", { className: "arrow" })),
                                React.createElement("ul", null,
                                    React.createElement("li", { className: "option", "data-value": "itemName" }, t("FIELD.모델명")),
                                    React.createElement("li", { className: "option", "data-value": "serialNo" }, t("FIELD.시리얼번호")))),
                            React.createElement("div", { className: "input__direct" },
                                React.createElement("input", { type: "text", placeholder: t("MESSAGE.T1입력하세요", [t("MESSAGE.검색어")]), value: searchText, onChange: (e) => setSearchText(e.target.value) }),
                                (searchText.length > 0) &&
                                    React.createElement("button", { type: "button", className: "btn btn-delete", onClick: (e) => setSearchText("") },
                                        React.createElement("span", { className: "hide" }, "\uC785\uB825 \uCC3D \uB2EB\uAE30"))),
                            React.createElement("button", { type: "button", id: "btn-search", className: "btn-search", "data-pop": "pop-search-small", onClick: (e) => (isSearchPop) ? CUTIL.jsopen_m_Popup(e) : onClickGoSearch(e) },
                                React.createElement("span", null, t("LABEL.조회"))),
                            React.createElement("button", { type: "button", className: "btn btn-filedown", onClick: (e) => excelList(e) },
                                React.createElement("span", { className: "hide" }, "\uB2E4\uC6B4\uB85C\uB4DC")),
                            React.createElement("button", { type: "button", className: `btn btn-delete-bg  ${(checkItem.length <= 0) ? "" : "bg-blue on"} ml-10 js-open`, "data-pop": "pop-delete", onClick: (checkItem.length <= 0) ? null : (e) => listCheckDelPop(e, checkItem) },
                                React.createElement("span", { className: "hide" }, "\uC0AD\uC81C"))))),
                React.createElement("p", { className: "nodata__txt" }, t("MESSAGE.데이터를찾을수없습니다")),
                React.createElement("div", { className: "tbl-list hcal-180" },
                    React.createElement("table", { summary: "\uB4F1\uB85D \uC21C,\uAE30\uAE30 \uBA85,Panel \uBA85,\uBAA8\uB378\uBA85,\uC2DC\uB9AC\uC5BC \uBC88\uD638,\uC815\uACA9\uC804\uC555,\uC815\uACA9\uC804\uB958,\uCC28\uB2E8\uC804\uB958,\uC815\uACA9\uC6A9\uB7C9,\uACC4\uD1B5\uC804\uC555,\uCCA8\uBD80\uD30C\uC77C,\uBA54\uBAA8 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC804\uAE30\uC2E4\uBAA9\uB85D \uC785\uB2C8\uB2E4." },
                        React.createElement("caption", null, "Basice-HCList"),
                        React.createElement("colgroup", null,
                            React.createElement("col", { style: {} })),
                        React.createElement("thead", null,
                            React.createElement("tr", null,
                                React.createElement("th", { scope: "col", className: "d-lm-none wmax-20" },
                                    React.createElement("input", { type: "checkbox", id: "t_all", checked: checkItem.length === 0 ? false : checkItem.length === deviceList.length ? true : false, onChange: (e) => checkedAll(e.target.checked) }),
                                    React.createElement("label", { htmlFor: "t_all" },
                                        React.createElement("span", { className: "hide" }, "\uC120\uD0DD"))),
                                React.createElement("th", { scope: "col", className: `sort ${(sortData.sortField === "rownumber") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} txt-left`, onClick: (e) => onClickSort("rownumber") },
                                    React.createElement("span", null, t("FIELD.등록순"))),
                                React.createElement("th", { scope: "col", className: ` sort ${(sortData.sortField === "spgName") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} txt-left`, onClick: (e) => onClickSort("spgName") },
                                    React.createElement("span", null, t("FIELD.기기명"))),
                                React.createElement("th", { scope: "col", className: ` sort ${(sortData.sortField === "panelName") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} txt-left`, onClick: (e) => onClickSort("panelName") },
                                    React.createElement("span", null, t("FIELD.Panel명"))),
                                React.createElement("th", { scope: "col", className: ` sort ${(sortData.sortField === "itemName") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} txt-left`, onClick: (e) => onClickSort("itemName") },
                                    React.createElement("span", null, t("FIELD.모델명"))),
                                React.createElement("th", { scope: "col", className: ` sort ${(sortData.sortField === "serialNo") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} txt-left`, onClick: (e) => onClickSort("serialNo") },
                                    React.createElement("span", null, t("FIELD.시리얼번호"))),
                                React.createElement("th", { scope: "col", className: ` sort ${(sortData.sortField === "ratingVoltage") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} txt-left d-lm-none`, onClick: (e) => onClickSort("ratingVoltage") },
                                    React.createElement("span", { className: "" },
                                        t("FIELD.정격전압"),
                                        " (kV)")),
                                React.createElement("th", { scope: "col", className: ` sort ${(sortData.sortField === "secondaryVoltage") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} txt-left d-lm-none`, onClick: (e) => onClickSort("secondaryVoltage") },
                                    React.createElement("span", { className: "" },
                                        t("FIELD.2차전압"),
                                        " (kV)")),
                                React.createElement("th", { scope: "col", className: ` sort ${(sortData.sortField === "ratingCurrent") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} txt-left d-lm-none`, onClick: (e) => onClickSort("ratingCurrent") },
                                    React.createElement("span", { className: "" },
                                        t("FIELD.정격전류"),
                                        " (A)")),
                                React.createElement("th", { scope: "col", className: ` sort ${(sortData.sortField === "cutoffCurrent") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} txt-left d-lm-none`, onClick: (e) => onClickSort("cutoffCurrent") },
                                    React.createElement("span", { className: "" },
                                        t("FIELD.차단전류"),
                                        " (kA)")),
                                React.createElement("th", { scope: "col", className: ` sort ${(sortData.sortField === "ratedCapacity") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} txt-left d-lm-none`, onClick: (e) => onClickSort("ratedCapacity") },
                                    React.createElement("span", { className: "" },
                                        t("FIELD.정격용량"),
                                        " (kVA)")),
                                React.createElement("th", { scope: "col", className: "d-lm-none" }, t("FIELD.첨부파일")),
                                React.createElement("th", { scope: "col", className: "d-lm-none" },
                                    React.createElement("span", null, t("FIELD.삭제"))))),
                        React.createElement("tbody", null, (deviceList) && deviceList.map((device, idx) => (React.createElement("tr", { key: `dv_${idx.toString()}`, className: `js-open-m ${(device.hasOwnProperty("selected")) ? (device.selected) ? "focused" : "" : ""}`, "data-pop": "pop-list-view" },
                            React.createElement("td", { className: "d-lm-none wmax-20" },
                                React.createElement("input", { type: "checkbox", id: "t_" + idx, checked: checkItem.includes(device) ? true : false, onChange: (e) => checkedList(e.target.checked, device) }),
                                React.createElement("label", { htmlFor: "t_" + idx },
                                    React.createElement("span", { className: "hide" }, "\uC120\uD0DD"))),
                            React.createElement("td", { className: "txt-left", onClick: (e) => onClickDeviceChang(e, device) }, device.rowNumber),
                            React.createElement("td", { className: "txt-left", onClick: (e) => onClickDeviceChang(e, device) }, device.spg.spgName),
                            React.createElement("td", { className: "txt-left", onClick: (e) => onClickDeviceChang(e, device) },
                                React.createElement("p", { className: "ellipsis wmax-140" },
                                    React.createElement("span", { className: "tooltip" },
                                        device.panel.panelName,
                                        React.createElement("span", { className: "tooltip-text" },
                                            " ",
                                            device.panel.panelName)))),
                            React.createElement("td", { className: "txt-left", onClick: (e) => onClickDeviceChang(e, device) },
                                React.createElement("p", { className: "ellipsis wmax-140" },
                                    React.createElement("span", { className: "tooltip" },
                                        device.itemName,
                                        React.createElement("span", { className: "tooltip-text", onClick: (e) => onClickDeviceChang(e, device) },
                                            device.itemName,
                                            " ")))),
                            React.createElement("td", { className: "txt-left", onClick: (e) => onClickDeviceChang(e, device) },
                                React.createElement("p", { className: "ellipsis wmax-140" },
                                    React.createElement("span", { className: "tooltip" },
                                        (device.serialNo) ? device.serialNo : "-",
                                        React.createElement("span", { className: "tooltip-text", onClick: (e) => onClickDeviceChang(e, device) },
                                            " ",
                                            (device.serialNo) ? device.serialNo : "-")))),
                            React.createElement("td", { className: "txt-left d-lm-none", onClick: (e) => onClickDeviceChang(e, device) }, (device.ratingVoltage) ? device.ratingVoltage : "-"),
                            React.createElement("td", { className: "txt-left d-lm-none", onClick: (e) => onClickDeviceChang(e, device) }, (device.secondaryVoltage) ? device.secondaryVoltage : "-"),
                            React.createElement("td", { className: "txt-left d-lm-none", onClick: (e) => onClickDeviceChang(e, device) }, (device.ratingCurrent) ? device.ratingCurrent : "-"),
                            React.createElement("td", { className: "txt-left d-lm-none", onClick: (e) => onClickDeviceChang(e, device) }, (device.cutoffCurrent) ? device.cutoffCurrent : "-"),
                            React.createElement("td", { className: "txt-left d-lm-none", onClick: (e) => onClickDeviceChang(e, device) }, (device.ratedCapacity) ? device.ratedCapacity : "-"),
                            React.createElement("td", { className: "d-lm-none", onClick: (e) => onClickDeviceChang(e, device) }, (device.imageId.length >= 1) ?
                                React.createElement("button", { type: "button", className: "btn btn-photo" },
                                    React.createElement("span", { className: "hide" }, "\uCCA8\uBD80\uD30C\uC77C"))
                                :
                                    React.createElement("button", { type: "button", className: "btn btn-photo", disabled: true },
                                        React.createElement("span", { className: "hide" }, "\uCCA8\uBD80\uD30C\uC77C"))),
                            React.createElement("td", { className: "d-lm-none" },
                                React.createElement("button", { type: "button", className: "btn btn-delete-gr js-open", "data-pop": "pop-delete", onClick: (e) => listDelPop(e, device) },
                                    React.createElement("span", { className: "hide" }, "\uC0AD\uC81C"))))))))),
                (pageInfo) && React.createElement(EhpPagination, { componentName: "DEVICELIST", pageInfo: pageInfo, handleFunc: handleCurPage })))));
}
export default DeviceList;
function MobileSearchPopup(props) {
    //trans
    const t = useTrans();
    const searchText = props.searchText;
    const setSearchText = props.setSearchText;
    const onClickGoSearch = props.onClickGoSearch;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("div", { className: "form__input mb-0" },
                React.createElement("div", { className: "select", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) },
                    React.createElement("div", { className: "selected" },
                        React.createElement("div", { className: "selected-value", "data-value": "itemName" }, t("FIELD.모델명")),
                        React.createElement("div", { className: "arrow" })),
                    React.createElement("ul", null,
                        React.createElement("li", { className: "option", "data-value": "itemName" }, t("FIELD.모델명")),
                        React.createElement("li", { className: "option", "data-value": "serialNo" }, t("FIELD.시리얼번호")))),
                React.createElement("input", { type: "text", placeholder: t("MESSAGE.T1입력하세요", [t("MESSAGE.검색어")]), value: searchText, onChange: (e) => setSearchText(e.target.value) }))),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray js-close" },
                React.createElement("span", null, t("LABEL.취소"))),
            React.createElement("button", { type: "button", className: "js-close", onClick: (e) => onClickGoSearch(e) },
                React.createElement("span", null, t("LABEL.적용"))))));
}
function MobileDeviceList(props) {
    //trans
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //const zoneInfo = props.zoneInfo;
    const searchText = props.searchText;
    const setSearchText = props.setSearchText;
    const workMode = props.workMdoe;
    const curTree = props.curTree;
    const deviceList = props.deviceList;
    const pageInfo = props.pageInfo;
    const handleCurPage = props.setPageInfo;
    const onClickGoSearch = props.onClickGoSearch;
    const onClickDeviceDetailView = props.onClickDeviceDetailView;
    const onClickDeviceTab = props.onClickDeviceTab;
    const sortData = props.sortData;
    const onClickSort = props.onClickSort;
    const setListWork = props.setListWork;
    const setListItem = props.setListItem;
    const setRestart = props.setRestart;
    const listDelPop = props.listDelPop;
    function onClickDeviceChang(e, device) {
        setListWork(true);
        if (CUTIL.isnull(device))
            return;
        setListItem(device);
        setRestart(false);
    }
    // 엑셀 다운로드 시 리스트 API
    function excelList(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let appPath = "roomId=" + curTree.room.roomId;
            appPath = appPath + '&page=' + pageInfo.number + '&size=' + pageInfo.totalElements;
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "GET",
                appPath: '/api/v2/product/company/zone/subzone/room/panel/itemManageList?' + appPath,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
                watch: appPath
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    excelDownloadSaved(data.body);
                }
            }
        });
    }
    const excelDownloadSaved = useCallback((excelData) => {
        const excelFileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'; // 파일 타입 및 유니코드
        // const book = XLSX.utils.book_new();
        const excelFileExtension = '.xlsx'; // 확장자 명
        const excelFileName = curTree.company.companyName + "_" + curTree.zone.zoneName + "_" + curTree.subZone.subZoneName + "_" + curTree.room.roomName + "_" + "DeviceList"; // 파일명
        const excelSheet = XLSX.utils.aoa_to_sheet([
            ['no', '기기유형', 'Panel명', "정격전압(kV)", "2차전압(kV)", "정격전류(A)", "차단전류(kA)", "정격용량(kVA)", "모델명", "시리얼번호", "제조사", "메모"]
        ]);
        excelData.map((sheet) => {
            XLSX.utils.sheet_add_aoa(excelSheet, [
                [
                    sheet.rowNumber,
                    sheet.spg.spgName,
                    sheet.panel.panelName,
                    sheet.ratingVoltage,
                    sheet.secondaryVoltage,
                    sheet.ratingCurrent,
                    sheet.cutoffCurrent,
                    sheet.ratedCapacity,
                    sheet.itemName,
                    sheet.serialNo,
                    sheet.manufacturer,
                    sheet.memo,
                ]
            ], { origin: -1 });
            excelSheet['!cols'] = [
                { width: 8, },
                { width: 10, },
                { width: 20, },
                { width: 13, },
                { width: 13, },
                { width: 13, },
                { width: 13, },
                { width: 13, },
                { width: 30, },
                { width: 30, },
                { width: 30, },
                { width: 30, },
            ];
            return false;
        });
        // wb == workBook 약자
        const wb = { Sheets: { Sheet: excelSheet }, SheetNames: ["Sheet"] };
        const excelButter = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const excelFile = new Blob([excelButter], { type: excelFileType });
        FileSaver.saveAs(excelFile, excelFileName + excelFileExtension);
        // XLSX.utils.book_append_sheet(book, excelSheet, "Sheet"); 
        // XLSX.writeFile(book, excelFileName + excelFileExtension);
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `popup__body` },
            React.createElement("ul", { className: "page-loca" },
                React.createElement("li", null, curTree.company.companyName),
                React.createElement("li", null, curTree.zone.zoneName),
                React.createElement("li", null, curTree.subZone.subZoneName),
                React.createElement("li", null, curTree.room.roomName)),
            React.createElement("div", { className: "page-top" },
                React.createElement("h2", null, curTree.room.roomName)),
            React.createElement("div", { className: "area__right_content workplace__info" },
                React.createElement("ul", { className: "tab__small" },
                    " ",
                    React.createElement("li", { className: (workMode === "CREATE") ? "on" : "" },
                        React.createElement("a", { href: "#", className: "icon-pen js-open-s", "data-pop": "pop-deviceadd", onClick: (e) => onClickDeviceTab(e, "CREATE") }, t("LABEL.개별등록")))),
                React.createElement("div", { className: "area__right_content hcal-170" },
                    React.createElement("div", { className: "inline right search-small mb-16 p-0 js-open-m open", "data-pop": "pop-search-small" },
                        React.createElement("p", { className: "title" },
                            React.createElement("span", null, t("LABEL.검색"))),
                        React.createElement("div", { className: "searcharea" },
                            React.createElement("div", { className: "searchinput" },
                                React.createElement("div", { className: "select" },
                                    React.createElement("div", { className: "selected" },
                                        React.createElement("div", { id: "search_selected-value", className: "selected-value", "data-value": "itemName" }, t("FIELD.모델명")),
                                        React.createElement("div", { className: "arrow" })),
                                    React.createElement("ul", null,
                                        React.createElement("li", { className: "option", "data-value": "itemName" }, t("FIELD.모델명")),
                                        React.createElement("li", { className: "option", "data-value": "serialNo" }, t("FIELD.시리얼번호")))),
                                React.createElement("div", { className: "input__direct" },
                                    React.createElement("input", { type: "text", placeholder: t("MESSAGE.T1입력하세요", [t("MESSAGE.검색어")]), className: "w274", value: searchText, onChange: (e) => setSearchText(e.target.value) }),
                                    React.createElement("button", { type: "button", className: "btn btn-delete" },
                                        React.createElement("span", { className: "hide" }, "\uC785\uB825 \uCC3D \uB2EB\uAE30"))),
                                React.createElement("button", { type: "button", className: "btn-search", "data-pop": "pop-search-small", onClick: (e) => CUTIL.jsopen_m_Popup(e) },
                                    React.createElement("span", null, t("LABEL.조회"))),
                                React.createElement("button", { type: "button", className: "btn btn-filedown", onClick: (e) => excelList(e) },
                                    React.createElement("span", { className: "hide" }, "\uB2E4\uC6B4\uB85C\uB4DC"))))),
                    React.createElement("div", { className: "tbl-list hcal-96" },
                        React.createElement("table", { summary: "\uB4F1\uB85D \uC21C,\uAE30\uAE30 \uBA85,Panel \uBA85,\uBAA8\uB378\uBA85,\uC2DC\uB9AC\uC5BC \uBC88\uD638,\uC815\uACA9\uC804\uC555,\uC815\uACA9\uC804\uB958,\uCC28\uB2E8\uC804\uB958,\uC815\uACA9\uC6A9\uB7C9,\uACC4\uD1B5\uC804\uC555,\uCCA8\uBD80\uD30C\uC77C,\uBA54\uBAA8 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC804\uAE30\uC2E4\uBAA9\uB85D \uC785\uB2C8\uB2E4." },
                            React.createElement("caption", null, "Basice-HCList"),
                            React.createElement("colgroup", null,
                                React.createElement("col", { style: { "width": "30%" } }),
                                React.createElement("col", { style: { "width": "70%" } })),
                            React.createElement("thead", null,
                                React.createElement("tr", null,
                                    React.createElement("th", { scope: "col", className: "d-lm-none wmax-20" },
                                        React.createElement("input", { type: "checkbox", id: "t_all" }),
                                        React.createElement("label", { htmlFor: "t_all" },
                                            React.createElement("span", { className: "hide" }, "\uC120\uD0DD"))),
                                    React.createElement("th", { scope: "col", id: "sort", className: `sort ${(sortData.sortField === "rownumber") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} txt-left`, onClick: (e) => onClickSort("rownumber") },
                                        React.createElement("span", null, t("FIELD.등록순"))),
                                    React.createElement("th", { scope: "col", className: ` sort ${(sortData.sortField === "spgName") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} txt-left d-sm-none`, onClick: (e) => onClickSort("spgName") },
                                        React.createElement("span", null, t("FIELD.기기명"))),
                                    React.createElement("th", { scope: "col", className: ` sort ${(sortData.sortField === "panelName") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} txt-left d-sm-none`, onClick: (e) => onClickSort("panelName") },
                                        React.createElement("span", null, t("FIELD.Panel명"))),
                                    React.createElement("th", { scope: "col", className: ` sort ${(sortData.sortField === "itemName") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} txt-left`, onClick: (e) => onClickSort("itemName") },
                                        React.createElement("span", null, t("FIELD.모델명"))),
                                    React.createElement("th", { scope: "col", className: ` sort ${(sortData.sortField === "serialNo") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} txt-left d-sm-none`, onClick: (e) => onClickSort("serialNo") },
                                        React.createElement("span", null, t("FIELD.시리얼번호"))),
                                    React.createElement("th", { scope: "col", className: ` sort ${(sortData.sortField === "ratingVoltage") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} txt-left d-lm-none`, onClick: (e) => onClickSort("ratingVoltage") },
                                        React.createElement("span", { className: "" },
                                            t("FIELD.정격전압"),
                                            " (kV)")),
                                    React.createElement("th", { scope: "col", className: ` sort ${(sortData.sortField === "secondaryVoltage") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} txt-left d-lm-none`, onClick: (e) => onClickSort("secondaryVoltage") },
                                        React.createElement("span", { className: "" },
                                            t("FIELD.2차전압"),
                                            " (kV)")),
                                    React.createElement("th", { scope: "col", className: ` sort ${(sortData.sortField === "ratingCurrent") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} txt-left d-lm-none`, onClick: (e) => onClickSort("ratingCurrent") },
                                        React.createElement("span", { className: "" },
                                            t("FIELD.정격전류"),
                                            " (A)")),
                                    React.createElement("th", { scope: "col", className: ` sort ${(sortData.sortField === "cutoffCurrent") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} txt-left d-lm-none`, onClick: (e) => onClickSort("cutoffCurrent") },
                                        React.createElement("span", { className: "" },
                                            t("FIELD.차단전류"),
                                            " (kA)")),
                                    React.createElement("th", { scope: "col", id: "sort_r", className: ` sort ${(sortData.sortField === "ratedCapacity") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} txt-left d-lm-none`, onClick: (e) => onClickSort("ratedCapacity") },
                                        React.createElement("span", { className: "" },
                                            t("FIELD.정격용량"),
                                            " (kVA)")),
                                    React.createElement("th", { scope: "col", className: "d-lm-none" }, t("FIELD.첨부파일")),
                                    React.createElement("th", { scope: "col", className: "d-lm-none" },
                                        React.createElement("span", null, t("FIELD.Memo"))))),
                            React.createElement("tbody", null, (deviceList) && (pageInfo.totalElements > 0) ?
                                deviceList.map((device, idx) => (React.createElement("tr", { key: `dv_${idx.toString()}`, className: `js-open-m ${(device.hasOwnProperty("selected")) ? (device.selected) ? "focused" : "" : ""}`, "data-pop": "pop-list-view", onClick: (e) => onClickDeviceChang(e, device) },
                                    React.createElement("td", { className: "d-lm-none wmax-20", "data-pop": "pop-list-view" },
                                        React.createElement("input", { type: "checkbox", id: "t_" + idx }),
                                        React.createElement("label", { htmlFor: "t_" + idx },
                                            React.createElement("span", { className: "hide" }, "\uC120\uD0DD"))),
                                    React.createElement("td", { className: "txt-left  ", "data-pop": "pop-list-view" /*  onClick={(e) => onClickDeviceChang(e, device)} */ }, device.rowNumber),
                                    React.createElement("td", { className: "txt-left  d-sm-none", "data-pop": "pop-list-view" /* onClick={(e) => onClickDeviceChang(e, device)} */ }, device.spg.spgName),
                                    React.createElement("td", { className: "txt-left  d-sm-none", "data-pop": "pop-list-view" /* onClick={(e) => onClickDeviceChang(e, device)} */ },
                                        React.createElement("p", { className: "ellipsis wmax-140", "data-pop": "pop-list-view" },
                                            React.createElement("span", { className: "tooltip" },
                                                device.panel.panelName,
                                                React.createElement("span", { className: "tooltip-text" /* onClick={(e) => onClickDeviceChang(e, device)} */ },
                                                    " ",
                                                    device.panel.panelName)))),
                                    React.createElement("td", { className: "txt-left " /* onClick={(e) => onClickDeviceChang(e, device)} */ },
                                        React.createElement("p", { className: "ellipsis wmax-140" },
                                            React.createElement("span", { className: "tooltip" },
                                                device.itemName,
                                                React.createElement("span", { className: "tooltip-text" /* onClick={(e) => onClickDeviceChang(e, device)} */ },
                                                    device.itemName,
                                                    " ")))),
                                    React.createElement("td", { className: "txt-left  d-sm-none" /* onClick={(e) => onClickDeviceChang(e, device)} */ },
                                        React.createElement("p", { className: "ellipsis wmax-140" },
                                            React.createElement("span", { className: "tooltip" },
                                                device.serialNo,
                                                React.createElement("span", { className: "tooltip-text" /* onClick={(e) => onClickDeviceChang(e, device)} */ },
                                                    " ",
                                                    device.serialNo)))),
                                    React.createElement("td", { className: "txt-left d-lm-none" /* onClick={(e) => onClickDeviceChang(e, device)} */ }, (device.ratingVoltage) ? device.ratingVoltage : "-"),
                                    React.createElement("td", { className: "txt-left d-lm-none" /* onClick={(e) => onClickDeviceChang(e, device)} */ }, (device.secondaryVoltage) ? device.secondaryVoltage : "-"),
                                    React.createElement("td", { className: "txt-left d-lm-none" /* onClick={(e) => onClickDeviceChang(e, device)} */ }, (device.ratingCurrent) ? device.ratingCurrent : "-"),
                                    React.createElement("td", { className: "txt-left d-lm-none" /* onClick={(e) => onClickDeviceChang(e, device)} */ }, (device.cutoffCurrent) ? device.cutoffCurrent : "-"),
                                    React.createElement("td", { className: "txt-left d-lm-none" /* onClick={(e) => onClickDeviceChang(e, device)} */ }, (device.ratedCapacity) ? device.ratedCapacity : "-"),
                                    React.createElement("td", { className: "d-lm-none" /* onClick={(e) => onClickDeviceChang(e, device)} */ }, (device.imageId.length >= 1) ?
                                        React.createElement("button", { type: "button", className: "btn btn-photo" },
                                            React.createElement("span", { className: "hide" }, "\uCCA8\uBD80\uD30C\uC77C"))
                                        :
                                            React.createElement("button", { type: "button", className: "btn btn-photo", disabled: true },
                                                React.createElement("span", { className: "hide" }, "\uCCA8\uBD80\uD30C\uC77C"))),
                                    React.createElement("td", { className: "d-lm-none" },
                                        React.createElement("button", { type: "button", className: "btn btn-delete-gr js-open", "data-pop": "pop-delete", onClick: (e) => listDelPop(e, device) },
                                            React.createElement("span", { className: "hide" }, "\uC0AD\uC81C"))))))
                                :
                                    React.createElement("tr", { key: `en_tr_no` },
                                        React.createElement("td", { colSpan: 7 },
                                            React.createElement("p", { className: "nodata-intable" }, t("MESSAGE.데이터를찾을수없습니다"))))))),
                    (pageInfo) && (deviceList.length > 0) && React.createElement(EhpPagination, { componentName: "DEVICELIST", pageInfo: pageInfo, handleFunc: handleCurPage }))))));
}
// 리스트 삭제
function DeletePopup(props) {
    //trans
    const t = useTrans();
    //recoil 
    const userInfo = useRecoilValue(userInfoLoginState);
    //props
    const listItem = props.listItem;
    const setReloadList = props.setReloadList;
    const setCheckItem = props.setCheckItem;
    const handleCurPage = props.handleCurPage;
    //
    // 삭제 API
    function listDel(itemId) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETEDATA",
                appPath: `/api/v2/product/company/zone/subzone/room/panel/item`,
                appQuery: {
                    itemId: itemId,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    alert("삭제되었습니다.");
                    handleCurPage(0);
                    setReloadList(true);
                    CUTIL.jsclose_Popup("pop-delete");
                }
                else {
                    alert(data.errorList[0].msg);
                }
            }
        });
    }
    // 중앙 정렬
    useEffect(() => {
        var btnCommentClose = document.getElementById("pop-delete");
        btnCommentClose.setAttribute("style", `position: absolute; top:${(window.innerHeight - btnCommentClose.scrollHeight) / 2 + "px"}; left:${(window.innerWidth - btnCommentClose.scrollWidth) / 2 + "px"} `);
    });
    // 완료 후 팝업
    function listDelDone(e) {
        var btnCommentClose = document.getElementById("pop-delete");
        var body = document.body;
        var dimm = body.querySelector(".dimm");
        if (!CUTIL.isnull(btnCommentClose))
            btnCommentClose.classList.add("hidden");
        if (!CUTIL.isnull(body))
            body.setAttribute("style", "overflow-y: auto;");
        if (!CUTIL.isnull(dimm))
            dimm.setAttribute("style", "delItme: none; z-index: 11; ");
        setReloadList(true);
        setCheckItem([]);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("p", null, "\uD574\uB2F9 \uAE30\uAE30\uB97C \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?")),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray btn-close", onClick: (e) => PopClols("pop-delete") },
                React.createElement("span", null, t("LABEL.취소"))),
            React.createElement("button", { type: "button", className: "", onClick: (e) => listDel(listItem) },
                React.createElement("span", null, t("LABEL.확인"))))));
}
// 일괄 삭제
function CheckDeletePopup(props) {
    //trans
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setRecoilIsLoadingBox = props.setRecoilIsLoadingBox;
    //props
    const listItem = props.listItem;
    const setReloadList = props.setReloadList;
    const setCheckItem = props.setCheckItem;
    const handleCurPage = props.handleCurPage;
    //
    const [delItme, setDelItme] = useState(null);
    // 삭제 API
    function listDel(e) {
        return __awaiter(this, void 0, void 0, function* () {
            var btnCommentClose = document.getElementById("pop-delete");
            if (!CUTIL.isnull(btnCommentClose))
                btnCommentClose.classList.add("hidden");
            let data = null;
            setRecoilIsLoadingBox(true);
            for (let i = 0; i < listItem.length; i++) {
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "DELETEDATA",
                    appPath: `/api/v2/product/company/zone/subzone/room/panel/item`,
                    appQuery: {
                        itemId: listItem[i],
                    },
                    userToken: userInfo.loginInfo.token,
                });
            }
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    alert("삭제되었습니다.");
                    handleCurPage(0);
                    setReloadList(true);
                    setRecoilIsLoadingBox(false);
                    CUTIL.jsclose_Popup("pop-delete");
                }
                else {
                    alert(data.errorList[0].msg);
                }
            }
        });
    }
    // 중앙 정렬
    useEffect(() => {
        var btnCommentClose = document.getElementById("pop-delete");
        btnCommentClose.setAttribute("style", `position: absolute; top:${(window.innerHeight - btnCommentClose.scrollHeight) / 2 + "px"}; left:${(window.innerWidth - btnCommentClose.scrollWidth) / 2 + "px"} `);
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("p", null,
                React.createElement("span", { className: "font-16" }, "\uD574\uB2F9 \uAE30\uAE30\uB97C \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?"),
                React.createElement("br", null)),
            React.createElement("dl", null,
                React.createElement("dt", null),
                React.createElement("dd", null))),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray btn-close", onClick: (e) => PopClols("pop-delete") },
                React.createElement("span", null, t("LABEL.취소"))),
            React.createElement("button", { type: "button", className: "", onClick: (e) => listDel(e) },
                React.createElement("span", null, t("LABEL.확인"))))));
}
function PopClols(id) {
    const btnCommentClose = document.getElementById(id);
    var body = document.body;
    var dimm = body.querySelector(".dimm");
    if (!CUTIL.isnull(btnCommentClose))
        btnCommentClose.classList.add("hidden");
    if (!CUTIL.isnull(body))
        body.setAttribute("style", "overflow-y: auto;");
    if (!CUTIL.isnull(dimm))
        dimm.setAttribute("style", "delItme: none; z-index: 11; ");
}
///
// function MobileDeviceDetail(props) {
//   const device = props.hasOwnProperty("deviceInfo") ? props.deviceInfo : null;
//   function onSumit(e) {
//     var btnCommentClose = document.getElementById("pop-list-view");
//     var body = document.body
//     if (!CUTIL.isnull(btnCommentClose)) btnCommentClose.classList.add("hidden");
//     if (!CUTIL.isnull(body)) body.setAttribute("style", "overflow-y: auto;")
//   }
//   return (
//     <>
//       {/*<!--리스트 상세 보기 팝업, 220804 수정 (항목 수정 추가 및 클래스 추가)-->*/}
//       {/*
//       <div id="pop-list-view" className="popup-layer js-layer layer-out hidden page-report page-detail page-workplace page-info page-list-view">
//         <div className="popup__head">
//           <h1>{(device)?device.itemName:"-"}</h1>
//           <button className="btn btn-close js-close"><span className="hide">닫기</span></button>
//     </div>*/}
//       {(device) && <div className="popup__body">
//         <div className="area__right_content workplace__info">
//           <div className="content__info">
//             <h3 className="hide">리스트 상세 정보</h3>
//             <ul>
//               <li>
//                 <p className="tit">기기 명</p>
//                 <p className="txt">{device.spg.spgName}</p>
//               </li>
//               <li>
//                 <p className="tit">{t("FIELD.모델명")}</p>
//                 <p className="txt">{device.itemName}</p>
//               </li>
//               <li>
//                 <p className="tit">시리얼 번호</p>
//                 <p className="txt">{device.serialNo}T</p>
//               </li>
//               <li>
//                 <p className="tit">정격전압 <span className="fontRegular">(kV)</span></p>
//                 <p className="txt">{(device.ratingVoltage) ? device.ratingVoltage : "-"}</p>
//               </li>
//               <li>
//                 <p className="tit">정격전류 <span className="fontRegular">(A)</span></p>
//                 <p className="txt">{(device.ratingCurrent) ? device.ratingCurrent : "-"}</p>
//               </li>
//               <li>
//                 <p className="tit">차단전류 <span className="fontRegular">(kA)</span></p>
//                 <p className="txt">{(device.cutoffCurrent) ? device.cutoffCurrent : "-"}</p>
//               </li>
//               <li>
//                 <p className="tit">정격용량 <span className="fontRegular">(kVA)</span></p>
//                 <p className="txt">{(device.gridVoltage) ? device.gridVoltage : "-"}</p>
//               </li>
//               <li>
//                 <p className="tit">계통전압 <span className="fontRegular">(kV)</span></p>
//                 <p className="txt">{(device.ratedCapacity) ? device.cutoffCurrent : "-"}</p>
//               </li>
//               <li>
//                 <p className="tit">첨부파일</p>
//                 {/*<p className="txt">*/}
//                 <ul className="filelist down">
//                   {(device.imageId)
//                     ? <li>
//                       <span>{device.imageId}</span>
//                       <button type="button" className="btn btn-filedown"><span className="hide">삭제</span></button>
//                     </li>
//                     : <li>
//                       <span>{"없음"}</span>
//                       <button type="button" className="btn btn-filedown" disabled={true}><span className="hide">삭제</span></button>
//                     </li>
//                   }
//                 </ul>
//                 {/*</p>*/}
//               </li>
//               <li>
//                 <p className="tit">메모</p>
//                 <p className="txt">{(device.memo && (device.memo.length > 0)) ? device.memo : "-"}</p>
//               </li>
//             </ul>
//           </div>
//           <div className="btn__wrap">
//             <button type="button" className="js-close" onClick={(e) => onSumit(e)}><span>{t("LABEL.확인")}</span></button>
//           </div>
//         </div>
//       </div>
//       }
//       {/*</div>*/}
//       {/*<!--//리스트 상세 보기 팝업-->*/}
//     </>
//   )
// }
